import { createFileRoute, Link, redirect } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { Button } from "@/components/ui/button";
import { usePolicy } from "@/lib/policy";
import { guardRoute } from "@/lib/policy/route-guard";
import { Home } from "./-components/home/home";
import { landingInsteadOfDashboard } from "./-components/home/home-landing";

export const Route = createFileRoute("/_authenticated/")({
  beforeLoad: ({ context }) => {
    guardRoute(context.me, "dashboard");
    const elsewhere = landingInsteadOfDashboard(context.me);
    if (elsewhere) throw redirect({ to: elsewhere, replace: true });
  },
  /* The dashboard, not a page for search: the public site is ppl-ai.com, and a visitor
     who is not signed in is sent to the login page. */
  head: () => ({
    meta: [{ title: "Dashboard | People AI" }, { name: "robots", content: "noindex, nofollow" }],
  }),
  component: DashboardPage,
});

/** Lenses the person may see, in their job's order; the server scopes every figure regardless. */
function DashboardPage() {
  const { me, subject } = usePolicy();
  if (subject.organization === null) {
    return (
      <PageHeader
        title="Platform"
        meta="Enter an organization from the platform console to see its dashboard."
        actions={
          <Button asChild>
            <Link to="/platform">Open platform console</Link>
          </Button>
        }
      />
    );
  }
  return <Home me={me} />;
}
